/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import {
  UserSelectRenderingFragmentDoc,
  GroupSelectRenderingFragmentDoc,
  IntrinsicGroupSelectRenderingFragmentDoc,
} from "./UserGroupSelect2.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type UserGroupSelectSearchQueryVariables = Types.Exact<{
  searchString: Types.Scalars["String"]["input"];
  orgId: Types.Scalars["OrgId"]["input"];
  searchUsers: Types.Scalars["Boolean"]["input"];
  searchGroups: Types.Scalars["Boolean"]["input"];
  searchIntrinsicGroups: Types.Scalars["Boolean"]["input"];
  userPageSize: Types.Scalars["Int"]["input"];
  groupPageSize: Types.Scalars["Int"]["input"];
  orgRoleFilter: Types.InputMaybe<ReadonlyArray<Types.OrgRole> | Types.OrgRole>;
}>;

export type UserGroupSelectSearchQuery = {
  readonly __typename: "Query";
  readonly searchOrgUsers?: ReadonlyArray<{
    readonly __typename: "User";
    readonly email: string;
    readonly active: boolean;
    readonly imageUrl: string | null;
    readonly orgRole: Types.OrgRole;
    readonly userName: string | null;
    readonly userId: c.UserId;
  }>;
  readonly searchOrgGroups?: ReadonlyArray<{
    readonly __typename: "Group";
    readonly fromDirectorySync: boolean;
    readonly groupName: string;
    readonly groupId: c.GroupId;
    readonly userGroupLinks: ReadonlyArray<{
      readonly __typename: "UserGroupLink";
      readonly id: c.UserGroupLinkId;
    }>;
  }>;
  readonly intrinsicGroups?: ReadonlyArray<{
    readonly __typename: "IntrinsicGroup";
    readonly userCount: number;
    readonly intrinsicGroupName: string;
    readonly intrinsicGroupId: Types.IntrinsicGroupId;
  }>;
};

export const UserGroupSelectSearchDocument = /*#__PURE__*/ gql`
  query UserGroupSelectSearch(
    $searchString: String!
    $orgId: OrgId!
    $searchUsers: Boolean!
    $searchGroups: Boolean!
    $searchIntrinsicGroups: Boolean!
    $userPageSize: Int!
    $groupPageSize: Int!
    $orgRoleFilter: [OrgRole!]
  ) {
    searchOrgUsers(
      orgId: $orgId
      searchString: $searchString
      pageSize: $userPageSize
      orgRoleFilter: $orgRoleFilter
    ) @include(if: $searchUsers) {
      ...UserSelectRenderingFragment
    }
    searchOrgGroups(
      orgId: $orgId
      searchString: $searchString
      pageSize: $groupPageSize
    ) @include(if: $searchGroups) {
      ...GroupSelectRenderingFragment
    }
    intrinsicGroups(orgId: $orgId) @include(if: $searchIntrinsicGroups) {
      ...IntrinsicGroupSelectRenderingFragment
    }
  }
  ${UserSelectRenderingFragmentDoc}
  ${GroupSelectRenderingFragmentDoc}
  ${IntrinsicGroupSelectRenderingFragmentDoc}
`;

/**
 * __useUserGroupSelectSearchQuery__
 *
 * To run a query within a React component, call `useUserGroupSelectSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupSelectSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupSelectSearchQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *      orgId: // value for 'orgId'
 *      searchUsers: // value for 'searchUsers'
 *      searchGroups: // value for 'searchGroups'
 *      searchIntrinsicGroups: // value for 'searchIntrinsicGroups'
 *      userPageSize: // value for 'userPageSize'
 *      groupPageSize: // value for 'groupPageSize'
 *      orgRoleFilter: // value for 'orgRoleFilter'
 *   },
 * });
 */
export function useUserGroupSelectSearchQuery(
  baseOptions: Apollo.QueryHookOptions<
    UserGroupSelectSearchQuery,
    UserGroupSelectSearchQueryVariables
  > &
    (
      | { variables: UserGroupSelectSearchQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    UserGroupSelectSearchQuery,
    UserGroupSelectSearchQueryVariables
  >(UserGroupSelectSearchDocument, options);
}
export function useUserGroupSelectSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserGroupSelectSearchQuery,
    UserGroupSelectSearchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UserGroupSelectSearchQuery,
    UserGroupSelectSearchQueryVariables
  >(UserGroupSelectSearchDocument, options);
}
export function useUserGroupSelectSearchSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    UserGroupSelectSearchQuery,
    UserGroupSelectSearchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    UserGroupSelectSearchQuery,
    UserGroupSelectSearchQueryVariables
  >(UserGroupSelectSearchDocument, options);
}
export type UserGroupSelectSearchQueryHookResult = ReturnType<
  typeof useUserGroupSelectSearchQuery
>;
export type UserGroupSelectSearchLazyQueryHookResult = ReturnType<
  typeof useUserGroupSelectSearchLazyQuery
>;
export type UserGroupSelectSearchSuspenseQueryHookResult = ReturnType<
  typeof useUserGroupSelectSearchSuspenseQuery
>;
export type UserGroupSelectSearchQueryResult = Apollo.QueryResult<
  UserGroupSelectSearchQuery,
  UserGroupSelectSearchQueryVariables
>;
